<script lang="ts" setup>
import DefinitionListSection from '../../DefinitionListSection.vue';
import HeadlineListSection from '../../HeadlineListSection.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';

defineProps<{
  imageNumber: number;
}>();
</script>
<template>
  <WhereToConsultCard
    title="iDeCoを始める際の注意点"
    :image-number="imageNumber"
  >
    <p>iDeCoを始める際は、次の注意点があることを覚えておきましょう。</p>
    <HeadlineListSection>
      <li><a href="#card3Step1">金融機関変更時の手数料</a></li>
      <li><a href="#card3Step2">スイッチング手数料の発生</a></li>
      <li><a href="#card3Step3">受取時の課税について</a></li>
    </HeadlineListSection>
    <h3 id="card3Step1">金融機関変更時の手数料</h3>
    <p>iDeCo専用口座の開設後、金融機関を変更することが可能です。</p>
    <p>
      ただし、金融機関によって手数料や取扱商品数が異なるため、変更前と変更後の金融機関それぞれで手数料が発生してしまいます。
    </p>
    <p>
      また、金融機関の変更時は保有資産の全てを一度売却する必要があり、売却するタイミングによっては資産が目減りする可能性もあります。
    </p>
    <p>
      基本的には後から変更する必要がないように、iDeCo専用口座を開設する金融機関は、慎重に選定することを心がけましょう。
    </p>
    <h3 id="card3Step2">スイッチング手数料の発生</h3>
    <p>iDeCoで運用中の銘柄を買い替えることを「スイッチング」と呼びます。</p>
    <p>
      投資信託にはあらかじめ複数の金融商品が含まれており、スイッチングを行うことで投資信託の一部を売却し、別の商品への組み換えが可能です。
    </p>
    <p>
      スイッチングを行うと、投資信託のリバランス（資産配分割合の調整）や一部商品の利益を確定させるなど、いくつかのメリットがあります。
    </p>
    <p>
      一方、スイッチングで投資信託を売却すると、信託財産留保額などの余計なコストが発生する場合があるので注意が必要です。
    </p>
    <h3 id="card3Step3">受取時の課税について</h3>
    <p>iDeCoによる老齢給付金は、受け取る際にも所得控除の対象となります。</p>
    <p>
      ただし、受取時の所得控除には限度額が設けられているため、受取方法や金額によっては課税対象となる場合があります。
    </p>
    <DefinitionListSection>
      <dt>iDeCoの老齢給付金が課税対象となるケース</dt>
      <dd>
        <ul>
          <li>
            年金形式で受け取る場合：公的年金（老齢基礎年金および老齢厚生年金）とiDeCoの受給額を合算し、公的年金等控除額を超過する場合
          </li>
          <li>
            一時金形式：退職金などの給付金とiDeCoの受給額を合算し、退職所得控除額を超過する場合
          </li>
        </ul>
      </dd>
    </DefinitionListSection>
    <p>
      ※公的年金等控除額については国税庁「<NuxtLink
        href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1600.htm"
        external
        target="_blank"
        >公的年金等の課税関係</NuxtLink
      >」をご確認ください<br />
      ※退職所得控除額については国税庁「<NuxtLink
        href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1420.htm"
        external
        target="_blank"
        >退職金を受け取ったとき（退職所得）</NuxtLink
      >」をご確認ください
    </p>
    <br />
    <p>
      iDeCo加入者が死亡した場合は遺族に対して「死亡一時金」が支給されますが、死亡一時金は相続税の課税対象となる点を覚えておきましょう。
    </p>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
